import { StyledFieldsWrapper } from "@components/inputs/field/FieldsWrapper.styles";
import styled from "styled-components";

import { T_HEADER_small, T_TITLE_4, T_TITLE_4_NORMAL } from "../../../global.style";

export const DayEditWrapper = styled.div`
    min-width: 455px;
    & > ${StyledFieldsWrapper} {
        margin-top: 30px;
    }
`;

export const CalendarWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 30px;
`;

export const CalendarGrid = styled.div`
    display: grid;
    grid-gap: 25px;
    grid-template-columns: repeat(7, 1fr);
`;

export const DayLabel = styled.div`
    text-transform: uppercase;
    ${T_TITLE_4};
    text-align: center;
    margin-bottom: -12px;
`;

export const Day = styled.div`
    ${T_TITLE_4_NORMAL};
    text-align: center;
`;

export const AdditionalInfo = styled.div`
    ${T_TITLE_4_NORMAL};
    align-self: flex-start;
    margin-top: 30px;
`;

export const MonthYearLabel = styled.div`
    ${T_HEADER_small};
    text-transform: capitalize;
    margin-bottom: 24px;
`;

export const AttendanceCalendarWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    column-gap: 38px;
    row-gap: 17px;
    width: 100%;
    justify-content: space-between;
    // 1310px is the width of the calendar + max width of day edit entries + gap between them 3 * 38px
    // unfortunately if any of those values change, this value has to be changed as well or desired behavior won't be achieved
    // https://app.zeplin.io/project/62eba2893ed4d9702ef1cc0f/screen/6746ec497f612cb6b5d86448
    max-width: 1310px;
`;